import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: #c50000;
  z-index: 9999;
  cursor: pointer;
  padding: 5px;
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
  
  p {
    margin: 0 0 0 10px;
  }
`;
